import { gsap } from 'gsap';
import { breakpoint } from './variables';

export function slideDown(element, duration = 400, callback) {
    gsap.from(element, {
        height: 0,
        duration: duration / 1000,
        ease: 'power2.out',
        clearProps: 'height',
        onComplete: () => {
            if (typeof callback === 'function') callback();
        },
    });
}

export function debounce(func, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    };
}

export function throttle(func, limit) {
    let lastCall = 0;
    let trailing;

    return function throttled(...args) {
        const now = Date.now();
        const remaining = limit - (now - lastCall);

        if (remaining <= 0) {
            if (trailing) {
                clearTimeout(trailing);
                trailing = undefined;
            }
            lastCall = now;
            func.apply(this, args);
        } else if (!trailing) {
            trailing = setTimeout(() => {
                lastCall = Date.now();
                trailing = undefined;
                func.apply(this, args);
            }, remaining);
        }
    };
}

export function formatFileSize(sizeInBytes) {
    const units = ['octets', 'Ko', 'Mo', 'Go'];
    let size = sizeInBytes;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
}

export function getSiblings(node) {
    if (!node || !node.parentNode) return [];
    return Array.from(node.parentNode.children).filter((child) => child !== node);
}

export function getMaxValue(array) {
    let max = array[0];

    for (let i = 1; i < array.length; ++i) {
        if (array[i] >= max) {
            max = array[i];
        }
    }

    return max;
}

export function getOffset(element) {
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset,
    };
}

export function getAdminBarHeight() {
    const adminBar = document.getElementById('wpadminbar');

    return !adminBar ? 0 : adminBar.offsetHeight;
}

export function getHeaderHeight() {
    const header = document.querySelector('.header');
    return !header ? 0 : header.offsetHeight;
}

export function getHeaderStickyHeight() {
    const header = document.querySelector('.header-main');
    return !header ? 0 : header.offsetHeight;
}

export function isElementPartiallyVisible(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

    return vertInView && horInView;
}

export function viewportWidth() {
    return {
        isDesktopNav: () => window.innerWidth >= breakpoint.laptop,
        isMobileNav: () => window.innerWidth < breakpoint.laptop,
        isTabletDown: () => window.innerWidth < breakpoint.tablet,
    };
}

// applique blanc ou noir en fonction de la couleur renseignée
export function setColorOn(hex, { lightColor = '#fff', darkColor = '#000', contrast = 165 } = {}) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= contrast ? darkColor : lightColor;
}
